module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-single-3-464303e42e9bddf2de21b41235997328.jpg";